import { ValidatorFn, ValidationErrors, AbstractControl } from "@angular/forms";

export class PasswordValidator {
  public static passwordConfirmationFailed: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const password = control.get("password");
    const passwordConfirmation = control.get("passwordConfirmation");
    return password?.value === passwordConfirmation?.value ? null : { passwordConfirmationFailed: true };
  };
}
